import React from 'react'
import PropTypes from 'prop-types'
import { Done, DoneAll } from '@material-ui/icons'
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Table,
  TableCell,
  TableRow,
  TextField,
  Switch,
  FormControlLabel
} from '@material-ui/core/'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SearchUserChipField from './SearchUserChipField'
import { CustomTooltip } from './CustomTooltip'
import IconButton from '@material-ui/core/IconButton/IconButton'
import CloseIcon from '@material-ui/icons/Close';
import extract_user from '../functions/extract'

export const ChooseAccount = props => {
  const { handleClose, open, users, handleSelect } = props;
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="choose-account"
      open={open}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="choose-account">Selecciona emisor</DialogTitle>
      <div>
        <List>
          {users.map(user => (
            <ListItem button onClick={() => handleSelect(user)} key={user.id}>
              <ListItemAvatar>
                <Avatar alt="avatar" className="avatar">{user.name.full.slice(0,2)}</Avatar>
              </ListItemAvatar>
              <ListItemText primary={user.name.full} secondary={extract_user(user.email)} />
            </ListItem>
          ))}
        </List>
      </div>
    </Dialog>
  );
};
export const ReadDetailDialog = props => {
  const { onClose, open, detail, readCount } = props;
  const seen = !!readCount>=1

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="choose-account"
      open={open}

    >
      <DialogTitle id="choose-account">
        {seen? (
          'Visto por '+readCount+ " de "+ detail.length
          ) : "Entregado a"
        }
        </DialogTitle>
      <div>
        <List className={'readDetailList'} >
          {detail.map(d => (
            <ListItem key={d.to !== null ? d.to.id : d.external_name+d.id}>
              <ListItemAvatar>
                <Avatar alt="avatar" className="avatar">{ d.to.name.full.slice(0,2) }</Avatar>
              </ListItemAvatar>
              <ListItemText primary={d.to.name.full} secondary={extract_user(d.to.email)} style={{paddingRight:'7em'}} />
              <ListItemSecondaryAction style={{paddingRight:'2em'}}>
                {d.read === true ? (
                    <CustomTooltip  title={'Visto: ' + d.read_date} placement="right">
                      <DoneAll />
                    </CustomTooltip>
                ) : (
                    <CustomTooltip  title="Entregado" placement="right">
                      <Done />
                    </CustomTooltip>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </div>
    </Dialog>
  );
};
export class FowardDialog extends React.Component {

  shouldComponentUpdate(nextProps, prevState){
    return(
      this.props.open !== nextProps.open ||
      this.props.twoFASuccess !== nextProps.twoFASuccess ||
      this.props.ccList !== nextProps.cclist ||
      this.props.ccNote !== nextProps.ccNote ||
      this.props.verified !== nextProps.verified
    )
  }

  onFoward = () => {
    document.getElementById("button_forward").style.display = "none";
    this.props.onFoward();
    this.props.onClose();
  };

  onClose = () => {
    this.props.onClose();
  };

  verify2FA = () => {
    this.props.onVerify2FA();
  }

  render() {
    const { onClose, open, ccList, onToChange, ccNote, onAddCC, onDeleteCC, onCcNoteChange, option, verified, onAddExternalCC } = this.props;
    let action = this.onFoward;
    let title = 'Reenviar a';
    let text_action = 'Enviar';

    if(option === 'authorize'){
      title = 'Reenviar con autorización';
      action = this.verify2FA;
      text_action = 'firmar';

      if(verified){
        text_action = 'Enviar';
        action = this.onFoward;
      }

      if(process.env.REACT_APP_DISABLED2FA === 'true'){
        text_action = 'enviar';
        action = this.onFoward;
      }

    }

    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="choose-account"
        open={open}
        maxWidth="md"
        fullWidth
        className="fix-modal"
      >
        <DialogTitle>{title}</DialogTitle>
          <Grid item xl={12} style={{padding:'0px 24px 0px 24px'}}>
            <SearchUserChipField
              onChange={onToChange}
              includeGroups
              ccList={ccList}
              onAddCC={onAddCC}
              onDeleteCC={onDeleteCC}
              ccNote={ccNote}
              onCcNoteChange={onCcNoteChange}
              onAddExternalCC={onAddExternalCC}
            />
          </Grid>
      <DialogActions style={{marginTop:'30px'}} className="button_modal">
        <Button onClick={this.onClose} color="primary" className="button_modal_medium">
          Cancelar
        </Button>
        <Button onClick={action} color="primary" className="button_modal_medium" id="button_forward"  disabled={this.props.ccNote !== "" && this.props.ccList.length > 0  ? false : true}>
          {text_action}
        </Button>
      </DialogActions>
      </Dialog>
    );
  }
}

export class FowardOptionsDialog extends React.Component {
  onClose = () => {
    this.props.onClose();
  };

  onFoward = (option) => {
    document.getElementById("button_forward").style.display = "none";
    this.props.openDialog(option);
    this.onClose();
  }

  render() {
    const { onClose, open } = this.props;
    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="options-foward"
        open={open}
        maxWidth="sm"
        className="fix-modal"
      >
        <DialogTitle>Reenviar oficio
          <IconButton onClick={this.onClose} className="close_fix_button" >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography align="justify" variant="body1">Reenviar un oficio con autorización significa que el titular del oficio autoriza el contenido del oficio.</Typography>
        </DialogContent>
      <DialogActions className="button_modal">
        <Button onClick={() => {this.onFoward('normal')} } color="primary" className="button_modal_medium">
          Reenviar
        </Button>
        <Button onClick={() => {this.onFoward('authorize')} } color="primary" className="button_modal_medium" id="button_forward">
          Reenviar con autorización
        </Button>
      </DialogActions>
      </Dialog>
    );
  }
}

export class CommentDialog extends React.Component {
  state = { revisionNotes: "", disableSendReview: false };

  onCommentChange = u => {
    this.setState({
      revisionNotes: u
    })

  };


  closeAndDisable = () => {
    this.props.onClose();
    this.setState({
      disableSendReview: true
    })
  }

  onSendComment = () => {
    this.props.onSendComment(this.state.revisionNotes);
    this.closeAndDisable();
  };

  onSendCommentApprove = () => {
    this.props.onSendCommentApprove(this.state.revisionNotes);
    this.closeAndDisable();
  };

  onClose = () => {
    this.props.onClose()
  }



  render () {
    const {onClose, open, previousNotes, role, docStatus, hasApprover} = this.props
    const {revisionNotes, disableSendReview} = this.state
    const dateOpt={  year: 'numeric', month: 'numeric', day: 'numeric' };

    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="choose-account"
        open={open}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Notas de revisión
          <IconButton onClick={this.onClose} className="close_fix_button" >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent >
          <Grid container spacing={8} >
            {role !== "owner"?
            <Grid item lg={12} md={12} sm={12} style={{ marginBottom: '1em'}}>
              <TextField
                multiline
                label="Notas"
                fullWidth
                inputProps={{
                  maxLength: 200
                }}
                disabled={docStatus === "rejected" || disableSendReview}
                value={revisionNotes}
                onChange={e => {
                  this.onCommentChange(e.target.value)
                }}
              />
            </Grid>
            : null}
            <Grid item lg={12} md={12} sm={12} style={{marginBottom: '.5em'}}>
              {previousNotes.length > 0 ? (
                <ExpansionPanel expanded={(role ==="delegated" || role === "isToUser" || role === "owner")? true: null}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography>Historial de notas</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Table>
                      <tbody>
                      {previousNotes.slice(0).reverse().map(d => (
                        <TableRow key={d.id}>
                          <TableCell key={d.id} style={{marginBottom: '1em', fontSize: '12px'}}>
                            {new Date(d.created_at).toLocaleDateString([], dateOpt) + ' [' + d.status.toUpperCase() + '] :   ' + d.note}
                          </TableCell>
                        </TableRow>
                      ))}
                      </tbody>
                    </Table>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ) : null}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={hasApprover?  this.onSendCommentApprove : this.onSendComment}
            disabled={docStatus ==="rejected" || revisionNotes.length ===0 || disableSendReview }
            color="primary">
            { ((hasApprover && role === 'isToUser' && docStatus ==="rejected") || (hasApprover && role !== 'isToUser' && (docStatus ==="inRevision" || docStatus ==="rejected")))? 'Regresado' : docStatus ==="rejected" || disableSendReview? "Pendiente de firma" : "Enviar revisión"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export const ModalConfirmation = props => {
  const { open, close, type, action, removeDelegate, addDelegate, user, editDelegate } = props;
  const [state, setState] = React.useState({
    reply: (typeof user.reply !== 'undefined')? user.reply : false,
    })

  const { reply } = state;
  let action_description = null;
  let action_execute = addDelegate;

  switch (type) {
    case 'reviewer':
      action_description = 'delegar como revisor';
      break;
    default:
      action_description = 'delegar';
  }

  if(action === 'Remove'){
    action_description = 'anular la delegación';
    action_execute = removeDelegate;
  }

  if(action === 'Edit'){
    action_description = 'modificar';
    action_execute = editDelegate;
  }

  const handleChangeReply = () => {
    setState({ reply: !reply });
  }

  let reply_option = null
  let options = null

  if(action !== 'Remove' && type === 'reviewer'){
    reply_option = (
      <FormControlLabel
        control={
          <Switch
            checked={reply}
            onChange={handleChangeReply}
            name="external"
            color="primary"
          />}
          label={reply? 'Activado' : 'Desactivado'}
        />
    );

    options = (
      <React.Fragment>
        <br/><br/>
        <Typography variant="h6" className="subsection_header">Activar permiso a delegado para:</Typography>
        <Grid container
            direction="row"
            alignItems="center">
              <Grid item xs={6} sm={6} md={6} lg={6}  xl={8}>
                <Typography variant="body1">Responder oficios dirigidos al titular </Typography>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6}  xl={4}>
                {reply_option}
              </Grid>
        </Grid>
      </React.Fragment>
    );
  }

  return(
    <Dialog
     open={open}
     onClose={close}
    >
     <DialogTitle id="draggable-dialog-title">Confirmación</DialogTitle>
     <DialogContent>
         ¿Realmente desea {action_description} a {user.name.full}?
         {options}
     </DialogContent>
     <DialogActions className="button_modal">
       <Button onClick={close} color="primary">
         Cancelar
       </Button>
       <Button onClick={() => action_execute(user, type, reply)} color="primary">
         aceptar
       </Button>
     </DialogActions>
   </Dialog>
  )
}

export const ErrorMessageModal = props => {
  const { open, close, message } = props;

  return(
    <Dialog
     open={open}
     onClose={close}
    >
     <DialogTitle id="draggable-dialog-title">Información</DialogTitle>
     <DialogContent>
         {message}
     </DialogContent>
     <DialogActions className="button_modal">
       <Button onClick={close} color="primary">
         Aceptar
       </Button>
     </DialogActions>
   </Dialog>
  )
}

FowardDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onFoward: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onAddCC: PropTypes.func.isRequired,
  onAddExternalCC: PropTypes.func.isRequired,
  onDeleteCC: PropTypes.func.isRequired,
  ccNote: PropTypes.string.isRequired,
  onCcNoteChange: PropTypes.func.isRequired
};

FowardOptionsDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

ReadDetailDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  detail: PropTypes.array.isRequired
};

ChooseAccount.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  handleSelect: PropTypes.func.isRequired
};

ModalConfirmation.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  removeDelegate: PropTypes.func.isRequired,
  addDelegate: PropTypes.func.isRequired,
};

ErrorMessageModal.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DocDialogs.js